import { render } from "./SkinStory.vue?vue&type=template&id=96982478"
import script from "./SkinStory.vue?vue&type=script&lang=js"
export * from "./SkinStory.vue?vue&type=script&lang=js"

import "./SkinStory.vue?vue&type=style&index=0&id=96982478&lang=css"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__